<template>
    <div>
        <header-nav :cur="5" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="teachtwo" @click="toteacher()">名师</span>
                    >
                    <span class="infor">名师详情</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">专业名师</div>
                        <div class="newbot">加入班级，更快速的成长</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 名师详情 -->
        <div class="navtab">
            <div class="detailbox">
                <div class="imgbox">
                    <img :src="$api.url+datss.teacherImage" alt="" />
                </div>
                <div class="right">
                    <div class="name">
                        {{datss.teacherName}}
                        <span>{{datss.academic}}</span>
                    </div>
                    <div class="content">
                        <div class="backg">教师简介</div>
                        {{datss.introduction}}
                    </div>
                    <div class="content">
                        <div class="backg">学历</div>
                        {{datss.education}}
                    </div>
                </div>
            </div>
        </div>
        <!-- 所受课程 -->
        <div class="navtab">
            <div class="classnav">所受课程</div>
        </div>

        <!-- 推荐课程 -->
        <div class="navtab">
            <div class="courselist">
                <div class="courbox" v-for="(item, index) in course" :key="index">
                    <div class="play">
                        <img src="../../assets/img/index/ico_live_broadcast.svg" alt="" />
                        直播
                    </div>
                    <div class="hour">{{ item.cour }}课时</div>
                    <img :src="item.img" alt="" />
                    <div class="tit">{{ item.title }}</div>
                    <div class="bottom">
                        <img :src="item.imgper" alt="" />
                        <span class="person">{{ item.person }}</span>
                        <span class="num">{{ item.num }}人</span>
                        <span class="money">￥{{ item.money }}</span>
                    </div>
                </div>
            </div>
        </div>
        <footer-nav />
    </div>
</template>
<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import {queryTeacherById, queryTeacherList} from "@/api/teacher";
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
            datss:{},
            course: [
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
                {
                    cour: '36',
                    img: require('../../assets/img/index/course.jpg'),
                    title: 'AI软件复杂立体LOGO绘制',
                    imgper: require('../../assets/img/index/course.jpg'),
                    person: '郭伟',
                    num: '383',
                    money: 800.0,
                },
            ],
        };
    },
   mounted() {
      this.datss=this.$route.query
      this.queryTeacherByIds(this.datss.wid)
   },
  methods: {
    toteacher() {
      this.$router.back(-1);
    },
    queryTeacherByIds(id) {
      queryTeacherById(id).then(res => {
        var list = res.rows;
        this.teachers = [];
        this.teachers = res.rows;
        this.total = res.total;
      })
    },
  }
};
</script>
<style lang="less" scoped>
  // 公共
  .navtab {
      width: 1280px;
      margin: 0 auto;
  }
  .color {
      color: #2961EF !important;
  }
  .ignore {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
  }
  // 搜索
  .nav {
      background: #f7f8fa;
      width: 100%;
      height: 177px;
      .top {
          display: block;
          font-size: 16px;
          font-weight: 300;
          color: #777777;
          padding: 19px 0 24px;
          .teachtwo {
              cursor: pointer;
          }
          .infor {
              color: #2961EF;
          }
      }
      .newbox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .newtop {
              font-size: 26px;
              color: #000000;
              margin-bottom: 5px;
          }
          .newbot {
              font-size: 16px;
              color: #888888;
          }
          .input {
              width: 497px;
              height: 59px;
              background: #ffffff;
              box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
              border-radius: 30px;
              position: relative;
              input {
                  border: none;
                  position: absolute;
                  left: 30px;
                  top: 0;
                  height: 59px;
                  line-height: 59px;
                  width: 365px;
                  font-size: 16px;
                  font-weight: 300;
                  color: #777777;
              }
              .select {
                  position: absolute;
                  right: 12px;
                  top: 8px;
                  width: 74px;
                  height: 43px;
                  line-height: 43px;
                  background: #2961EF;
                  border-radius: 30px;
                  font-size: 16px;
                  font-weight: 300;
                  color: #ffffff;
                  text-align: center;
              }
          }
      }
  }
  // 名师详情
  .detailbox {
      margin: 38px 0;
      display: flex;
      .imgbox {
          width: 288px;
          height: 282px;
          padding: 10px;
          background: #f7f8fa;
          border: 1px solid #f7f8fa;
          margin-right: 24px;
          img {
              width: 100%;
              height: 100%;
          }
      }
      .right {
          width: 100%;
          .name {
              font-size: 26px;
              font-weight: 600;
              color: #333333;
              span {
                  font-size: 16px;
                  font-weight: 300;
                  color: #2961EF;
              }
          }
          .content {
              font-size: 16px;
              color: #666666;
              margin: 26px 0;
              .backg {
                  font-size: 18px;
                  color: #0b7eff;
                  margin-bottom: 13px;
              }
          }
      }
  }
  // 所受课程
  .classnav {
      height: 40px;
      line-height: 40px;
      background: #f7f8fa;
      font-size: 18px;
      color: #0b7eff;
      padding-left: 18px;
  }
  // 推荐课程
  .courselist {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      margin-top: 22px;
      margin-bottom: 50px;
      .courbox {
          border-radius: 5px 5px 5px 5px;
          border: 1px solid #f1f1f1;
          padding: 10px 10px 0;
          width: 17.4%;
          margin-bottom: 18px;
          position: relative;
          margin-right: 1%;
          &:nth-child(5n) {
              margin-right: 0;
          }
          .play {
              position: absolute;
              top: 15px;
              left: 15px;
              background: rgba(255, 106, 0, 0.8);
              border-radius: 5px 5px 5px 5px;
              padding: 3px 10px;
              font-size: 14px;
              color: #ffffff;
              img {
                  margin-right: 5px;
              }
          }
          .hour {
              position: absolute;
              top: 15px;
              right: 15px;
              background: rgba(255, 106, 0, 0.8);
              border-radius: 5px 5px 5px 5px;
              padding: 3px 10px;
              font-size: 14px;
              color: #ffffff;
          }
          img {
          }
          .tit {
              font-size: 14px;
              color: #383838;
              margin-bottom: 25px;
          }
          .bottom {
              height: 40px;
              border-top: 1px solid #f1f1f1;
              img {
                  vertical-align: middle;
                  width: 21px;
                  height: 21px;
                  border-radius: 50%;
              }
              .person {
                  vertical-align: middle;
                  line-height: 41px;
                  padding: 0 15px 0 10px;
                  font-size: 14px;
                  color: #888888;
                  &::after {
                      content: '';
                      border: 1px solid rgba(112, 112, 112, 0.3);
                      height: 2px;
                      margin-left: 10px;
                  }
              }
              .num {
                  vertical-align: middle;
                  line-height: 41px;
                  font-size: 14px;
                  color: #888888;
              }
              .money {
                  vertical-align: middle;
                  line-height: 41px;
                  font-size: 14px;
                  color: #2961EF;
                  float: right;
              }
          }
      }
  }

</style>
